export enum AvErrorMessageEnum {
  LOAD_AV_ERROR = 'loadAvError',
  CRYPT_ID_ERROR = 'cryptIdError',
  EINREICHEN_ERROR = 'einreichenError',
}
